var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"Modal",attrs:{"buttons":['cancel', 'save'],"loading":_vm.loading,"title":_vm.title,"extraLarge":""},on:{"save":function($event){return _vm.$refs.Form.save()}}},[_c('Form',{ref:"Form",on:{"save":_vm.handleExit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }